import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-big-spinner',
  template: `
    <mat-spinner class="rounded-spinner" style="margin: 0 auto" [diameter]="diameter" [value]="value" mode="determinate"></mat-spinner>
    <div style="position: absolute; top: 0px;">
        <svg preserveAspectRatio="xMidYMid meet" focusable="false" ng-reflect-ng-switch="false" viewBox="0 0 122 122" [ngStyle]="{'width': diameter, 'height': diameter}">
        <circle cx="50%" cy="50%" r="55" class="spinner-background"></circle>
        </svg>
        <div class="inner-content" [ngStyle]="{'top': diameter/2 - 10 + 'px'}">
            <ng-content></ng-content>
        </div>
    </div>
    <span *ngIf="display_starting_dot" class="circle-dot"></span>
  `,
  styles: [
    `
      .spinner-background {
          stroke-dashoffset: 172.788px;
          stroke-width: 10%;
          position: absolute;
          transform: rotate(-90deg);
          top: 0;
          left: 0;
          transform-origin: center;
          overflow: visible;
          stroke: lightgray;
          fill: transparent;
      }

      .rounded-spinner {
          z-index: 999;
      }

      .inner-content {
          position: absolute;
          font-size: 24px;
          width: 100%;
          text-align: center;
      }

      .circle-dot {
          height: 10px;
          width: 10px;
          background-color: #ecf1f3;
          border-radius: 50%;
          position: absolute;
          top: 4.5px;
      }

      ::ng-deep .rounded-spinner circle {
          stroke-linecap: round;
      }
    `
  ]
})
export class NgxBigSpinnerComponent implements OnInit {

  @Input() diameter = 25;
  @Input() value = 0;
  @Input() display_starting_dot = false;

  constructor() { }

  ngOnInit(): void {
  }

}
